var map = {
	"./sample_map0.png": "./src/assets/images/sample_map0.png",
	"./sample_map1.png": "./src/assets/images/sample_map1.png",
	"./sample_map10.png": "./src/assets/images/sample_map10.png",
	"./sample_map2.png": "./src/assets/images/sample_map2.png",
	"./sample_map3.png": "./src/assets/images/sample_map3.png",
	"./sample_map9.png": "./src/assets/images/sample_map9.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/sample_map.*\\.png$";